import { render, staticRenderFns } from "./CustomColumn.vue?vue&type=template&id=d8becb90&scoped=true"
import script from "./CustomColumn.vue?vue&type=script&lang=js"
export * from "./CustomColumn.vue?vue&type=script&lang=js"
import style0 from "./CustomColumn.vue?vue&type=style&index=0&id=d8becb90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8becb90",
  null
  
)

export default component.exports